import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import AnimatedRoutes from './components/AnimatedRoutes';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/css/bootstrap.css';


// React Router Dom
import { BrowserRouter } from "react-router-dom";

// Al hacer uso de Redux para poder tener un State global:
import { store } from './StoreRedux'
import { Provider } from 'react-redux'


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <AnimatedRoutes />
    </Provider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
